/**
 * Cart View
 */
class CartView {

	constructor(presenter) {

		this.presenter = presenter;
		this.shoppingCart = $("#shopping-cart-offcanvas");
		this.shoppingCartTbody = $("#shopping-cart-tbody");
		this.shoppingCartRow1 = $("#shopping-cart-row1");
		this.shoppingCartRow2 = $("#shopping-cart-row2");
		this.shoppingCartRow3 = $("#shopping-cart-row3");
		this.shoppingCartTotal = $("#shopping-cart-total");
		this.shoppingCartCheckout = $("#shopping-cart-checkout");

		/*
		 * Listeners
		 */

		this.shoppingCart.on("show.bs.offcanvas", $.proxy(function(_event) {
			this.presenter.showingCart();
		}, this));

	}

	/*
	 * Actions
	 */

	/*
	 * Getters and Setters
	 */

	setCart(cart) {
				
		// we update the user interface by firstly clearing it of any dynamically loaded elements
		$("[id^=shopping-cart-product-id-").each(function() { $(this).remove(); });
		$("[id^=shopping-cart-variant-id-").each(function() { $(this).remove(); });
		$("[id^=shopping-cart-discount-variant-id-").each(function() { $(this).remove(); });
		
		// iterate the items and add the product and variant info
		var items = cart.items;
		var presenter = this.presenter;
		for (var i = 0; i < items.length; i++) {

			var item = items[i];

			// check to see if row 1 for this product already exists
			var row1 = $("#shopping-cart-product-id-" + item.product_id);
			if (row1.length == 0) {

				// it doesn't, so create row 1 that holds the product information
				var row1 = this.shoppingCartRow1.clone();
				row1.attr("id", "shopping-cart-product-id-" + item.product_id);
				row1.children().eq(0).find("h6").text(item.product_title);
				row1.removeClass("d-none");
				this.shoppingCartTbody.prepend(row1);

			}

			// we always create row two, as this holds the variant information
			var row2 = this.shoppingCartRow2.clone();
			row2.attr("id", "shopping-cart-variant-id-" + item.id);
			row2.attr("data-variant-id", item.id);
			row2.attr("data-quantity", item.quantity);
			row2.children().eq(0).text(item.variant_title + ":");
			row2.children().eq(1).text(Model.formatMoney(item.original_price, true));
			row2.children().eq(3).find("div > div").text(item.quantity);
			row2.children().eq(4).text(Model.formatMoney(item.original_line_price, true));
			row2.removeClass("d-none");
			row1.after(row2);

			// items that have zero value after being discounted can only have a quantity of one, so disable the quantity change buttons
			if (item.discounted_price == 0) {
				row2.children().eq(3).find("a").addClass("disabled");
			}

			// check to see if there is a discount for this variant
			if (item.line_level_total_discount > 0) {
				// add the discount row
				var row3 = this.shoppingCartRow3.clone();
				row3.attr("id", "shopping-cart-discount-variant-id-" + item.id);
				if (item.discounts.length > 0) { row3.children().eq(0).find("span").text(item.discounts[0].title + " Applied"); }
				row3.children().eq(1).text(Model.formatMoney(item.final_line_price, true));
				row3.removeClass("d-none");
				row2.after(row3);
				// strike out the original line price in row 2
				row2.children().eq(4).addClass("text-decoration-line-through");
			}

			// listen for quantity change events (including deletion)
			row2.find("a").on("click", function(_event) {
				
				// get the variant id for this row, and the current quantity and "action" to be taken
				var row = $(this).closest("tr");
				var variantId = row.attr("data-variant-id");
				var quantity = parseInt(row.attr("data-quantity"));
				var action = parseInt($(this).attr("data-action"));	// 0 = delete, -1 = decrease, +1 = increase
				
				// compute the new quantity and call for the cart item to be updated
				if (action == 0) { quantity = 0; } else { quantity = quantity + action; }
				presenter.updateItemQuantity(variantId, quantity);

			});

		}

		// set the total and enable/disable the checkout button
		const total = "<small>" + Model.CURRENCY_CODE + "</small>&nbsp;" + Model.formatMoney(cart.total_price, true);
		this.shoppingCartTotal.html(total);
		if (items.length > 0) {
			this.shoppingCartCheckout.removeClass("disabled");
			this.shoppingCartCheckout.removeClass("btn-outline-secondary");
			this.shoppingCartCheckout.addClass("btn-outline-danger");
		}
		else {
			this.shoppingCartCheckout.addClass("disabled");
			this.shoppingCartCheckout.addClass("btn-outline-secondary");
			this.shoppingCartCheckout.removeClass("btn-outline-danger");
		}

	}

	showCart() {
		
		// show the cart
		const bootstrapCart = new bootstrap.Offcanvas(this.shoppingCart);
		bootstrapCart.show();

	}

}
